import MastercardIcon from "@icons/MastercardIcon";
import VisaIcon from "@icons/VisaIcon";

import { Flex } from "@chakra-ui/react";

import { Text } from "@components/Text";

interface PropTypes {
    isHundredPercentOff: boolean;
    cardId: string;
    isSelected: boolean;
    cardBrand: string;
    maskedNumber: string;
    onSelectExistingCard: (id: string) => void;
}

const ExistingCard = ({
    cardBrand,
    cardId,
    isHundredPercentOff,
    isSelected,
    maskedNumber,
    onSelectExistingCard
}: PropTypes) => {
    return (
        <Flex
            onClick={() => {
                if (!isHundredPercentOff) onSelectExistingCard(cardId);
            }}
            key={cardId}
            justify="space-between"
            bg="gray.300"
            px={6}
            py={5}
            w="full"
            borderRadius={15}
            cursor="pointer"
            transition="all 0.2s"
            border="2px solid transparent"
            userSelect="none"
            background={`linear-gradient(${
                isSelected ? "white" : "var(--euka-colors-gray-100)"
            } 0 0) padding-box, ${
                isSelected ? "#F0A32F" : "var(--euka-colors-gray-300)"
            } border-box`}
            alignItems="center"
        >
            <Flex gap={8} alignItems="center">
                {cardBrand === "visa" && <VisaIcon width={26} height={20} />}
                {cardBrand === "mastercard" && (
                    <MastercardIcon width={26} height={20} />
                )}
                <Text
                    fontFamily="infini, sans-serif"
                    fontWeight="bold"
                    fontSize={14}
                >
                    {maskedNumber.match(/.{1,4}/g)?.join(" ")}
                </Text>
            </Flex>
            <Text fontSize={14}>
                {cardBrand.charAt(0).toUpperCase() + cardBrand.slice(1)}
            </Text>
        </Flex>
    );
};

export default ExistingCard;
